// extracted by mini-css-extract-plugin
export default {"commentsContainer":"xO9v1o"};